import React, { useState, useEffect } from 'react'
import Pagination from '@mui/material/Pagination';

const PaginationPage = ({ totalCount, paginationHandler, pageNumber, paginationHandlerNew, noOfRows }) => {
    const [page, setPage] = useState(pageNumber);
    const [rowsPerPage, setRowsPerPage] = useState(noOfRows);
    const [display, setDisplay] = useState({ start: 1, end: 1 })

    const setMinMaxHandler = (page, rowsPerPage) => {
        let displayData = Object.assign({}, display)
        displayData.start = (page * rowsPerPage) - (rowsPerPage - 1)
        displayData.end = Math.min(Number(displayData.start) + Number(rowsPerPage - 1), totalCount)
        setDisplay(displayData)
    }

    useEffect(() => {
        setMinMaxHandler(page, rowsPerPage)
    }, [totalCount])

    const handleChange = (event, value) => {
        setPage(value);
        setMinMaxHandler(value, rowsPerPage)
        paginationHandler(value, noOfRows)
    };

    const handleChangeRowsPerPage = (e) => {

        if (e.target.value === totalCount) {
            paginationHandler(1, totalCount)
            setRowsPerPage(e.target.value)
            setMinMaxHandler(1, totalCount)
        } else {
            if (e.target.value === 25 || e.target.value === '25' || e.target.value === 100 || e.target.value === '100' || e.target.value === 50 || e.target.value === '50') {
                paginationHandler(1, e.target.value)
                setRowsPerPage(e.target.value)
                setMinMaxHandler(1, e.target.value)
            } else {
                paginationHandler(page, e.target.value)
                setRowsPerPage(e.target.value)
                setMinMaxHandler(page, e.target.value)
            }
        }
    };
    //    const paginationHandlerNew=()=>{

    //     }
    return (
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-sm-4 col-xs-12 paginationBtn' onClick={() => paginationHandlerNew('main-left', pageNumber)}>
                    <button className='' style={{ width: '100%', color: '#fff' }} >
                        <i className='fa fa-angle-double-left'></i>
                    </button>
                </div>
                <div className='col-sm-1 col-xs-12 paginationBtn-small' onClick={() => paginationHandlerNew('left', pageNumber)}>
                    <button className='' style={{ width: '100%', color: '#fff' }}>
                        <i className='fa fa-angle-left'></i>
                    </button>
                </div>
                <div className='col-sm-2 col-xs-12 text-center'>
                    <div className=''>
                        <div> Page Number : {pageNumber}</div>

                        <div> Total Counts :{totalCount}</div>
                    </div>
                </div>
                <div className='col-sm-1 col-xs-12 paginationBtn-small' onClick={() => paginationHandlerNew('right', pageNumber)}>
                    <div>
                        <button className='' style={{ width: '100%', color: '#fff' }}>
                            <i className='fa fa-angle-right'></i>
                        </button>
                    </div>
                </div>
                <div className='col-sm-4 col-xs-12 paginationBtn' onClick={() => paginationHandlerNew('main-right', pageNumber)}>
                    <button className='' style={{ width: '100%', color: '#fff' }} >
                        <i className='fa fa-angle-double-right'></i>
                    </button>
                </div>
            </div>

        </div>

        // // totalCount >= noOfRows ?
        // <div className='pagination-container'>
        //     {/* {console.log(totalCount)} */}
        //     <div className='left'>
        //         {/* {pageNumber===1? */}

        //         <div>
        //             <span>Rows per page:&nbsp;&nbsp;&nbsp;&nbsp;</span>
        //             <select className='pagination-dd' onChange={e => handleChangeRowsPerPage(e)} value={rowsPerPage}>

        //                 {/* <option value={Math.round(totalCount%10)}>{Math.round(totalCount%10)}</option> */}
        //                 {/* <option value={Math.round(totalCount % 10)}>{Math.round(totalCount % 10)}</option>
        //                 {console.log((totalCount % 100) - 10,totalCount % 10)}
        //                 {(totalCount % 100) - 10  > totalCount % 10 ? <option value={Math.round((totalCount % 100) - 10 % 10)}>{Math.round((totalCount % 100) - 10 % 100)}</option> : ""}
        //                 {(totalCount % 100) - 20  > totalCount % 20 > totalCount % 100 ? <option value={Math.round((totalCount % 100) - 20 % 10)}>{Math.round((totalCount % 100) - 20 % 100)}</option> : ""}
        //                 {(totalCount % 100) - 30  > totalCount % 30 > totalCount % 100 ? <option value={Math.round((totalCount % 100) - 30 % 10)}>{Math.round((totalCount % 100) - 30 % 100)}</option> : ""} */}

        //                 {/* <option value={Math.round(totalCount-20 % 100)}>{Math.round(totalCount-20 % 100)}</option> */}
        //                 <option value={10}>10</option>

        //                 <option value={25}>25</option>
        //                 {/* {totalCount > 50 ? */}
        //                     <option value={50}>50</option>
        //                     {/* : ""} */}
        //                 {/* {totalCount > 51 ? */}

        //                     <option value={100}>100</option>
        //                     {/* // : ""} */}
        //                 {/* <option value={totalCount}>Show All </option> */}

        //             </select>
        //             <span>&nbsp;&nbsp;&nbsp;&nbsp;{(display.start) <= totalCount ? display.start : 1 + ' to ' + display.end} of {totalCount}&nbsp;&nbsp;&nbsp;&nbsp;</span>
        //         </div>
        //         {/* :""}  */}
        //     </div>
        //     <div className='right'>
        //         <Pagination
        //             count={Math.ceil(totalCount / rowsPerPage)}
        //             showFirstButton
        //             showLastButton
        //             page={page}
        //             onChange={handleChange}
        //             size="small"
        //             defaultPage={3}
        //             siblingCount={0}
        //         />
        //     </div>
        // </div>
        // : null
    )
}

export default PaginationPage;